<template>
  <div>
    <group-select-product-pop ref="selectRef" @handleConfirm="handleConfirmSelectProduct"></group-select-product-pop>
    <mul-set-commission-rate ref="mulSetCommissionRef" @handleUpdateRate="handleUpdateRate"></mul-set-commission-rate>
    <el-dialog
        title="佣金设置"
        :visible.sync="dialogVisible"
        :close-on-click-modal="false"
        top="10vh"
        width="1000px">
      <template #default>
        <div class="forms-container" style="display: flex;gap: 10px;justify-content: flex-end;margin-bottom: 10px;">
          <el-button @click="handleSelectProduct" type="primary">选择商品</el-button>
          <el-button type="primary" @click="handleMulSetCommissionRate">批量设置佣金比例</el-button>
        </div>
        <el-table
          ref="multipleTableRef"
          :data="tableList.list"
          v-loading="loading"
          @selection-change="handleSelectionChange"
          highlight-current-row
          border
          max-height="500px"
          style="width: 100%"
        >
          <el-table-column
              type="selection"
              width="55">
          </el-table-column>
          <el-table-column prop="templateCode" label="商品ID" width="230"/>
          <el-table-column prop="name" label="商品名称" />
          <el-table-column prop="commissionRate" width="150" label="佣金比例" >
            <template slot-scope="scope">
              <div style="display: flex;align-items: center;gap: 10px">
                <el-input v-model="scope.row.commissionRate" @input=" value => { handleInput(value, scope.row)}"/>
                <div>%</div>
              </div>
              <div style="color: red" v-if="scope.row.customErrorMsg">
                {{ scope.row.customErrorMsg }}
              </div>
            </template>
          </el-table-column>
          <el-table-column width="140" align="center" label="操作">
            <template slot-scope="scope">
              <el-button type="text" @click="handleDelete(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
            v-if="tableList.total > 0"
            class="pagination"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tableList.currentPage"
            :page-sizes="[10, 20, 30, 40]"
            :page-size="tableList.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="tableList.total"
        >
        </el-pagination>
      </template>
      <template #footer>
        <div style="display: flex;justify-content: flex-end;gap: 10px;">
          <el-button @click="handleClose">取 消</el-button>
          <el-button :loading="saveLoading" :disabled="changedItems.length === 0 && !saveLoading" type="primary" @click="handleConfirm">确 定</el-button>
        </div>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import debounce from "@/utils/debounce.js";
import mini from "@/api/poi";
import GroupSettingPop from "./groupSettingPop.vue";
import GroupSelectProductPop from "./groupSelectProductPop.vue";
import {formatPositiveIntegerInput} from "../../../../../utils/regExp";
import MulSetCommissionRate from "./mulSetCommissionRate.vue";
const poiApi = new mini();

export default {
  components: {
    MulSetCommissionRate,
    GroupSelectProductPop,
    GroupSettingPop
  },
  computed:{
    changedItems(){
      return this.tableList.list.filter(currentItem => {
        const originalItem = this.backupList.find(o => o.id === currentItem.id);
        return originalItem && originalItem.commissionRate !== currentItem.commissionRate;
      });
    }
  },
  data() {
    return {
      dialogVisible: false,
      saveLoading: false,
      searchForm: {
        searchContent: '',
      },
      groupRow:{},
      multipleSelection:[],
      params: {
        pageNo: 1,
        pageSize: 10,
      },
      loading: false,
      backupList:[],
      tableList:{
        pageSize: 10,
        currentPage: 1,
        total: 0,
        list:[],
      },
    };
  },
  methods: {
    handleUpdateRate(value){
      this.handleClearValidate()
      const filter = this.multipleSelection.map((item) => item.id)
      this.$refs.multipleTableRef.clearSelection();
      this.tableList.list.filter((data => {
        return filter.includes(data.id)
      })).forEach(item=>{
        this.$nextTick(()=>{
          this.$set(item,"commissionRate", value)
        })
      })
    },
    handleMulSetCommissionRate(){
      if(this.multipleSelection.length === 0){
        this.$message.warning('请选择商品')
        return;
      }
      this.$refs.mulSetCommissionRef.open()
    },
    handleClearValidate(){
      this.tableList.list.forEach((item) => {
        this.$set(item,"customErrorMsg", '')
      })
    },
    async handValidate(){
      return new Promise((resolve, reject)=>{
        this.handleClearValidate()
        this.tableList.list.forEach(item=>{
          if(!item.commissionRate){
            this.$set(item,"customErrorMsg", '请输入1-29的整数')
          }else if( item.commissionRate < 1 || item.commissionRate > 29){
            this.$set(item,"customErrorMsg", '请输入1-29的整数')
          }
        })
        const flag = this.tableList.list.some(item => item.customErrorMsg)
        if(flag){
          return reject('表单校验未通过')
        }else{
          return resolve(true)
        }
      })
    },
    handleInput(value,item){
      this.$nextTick(()=>{
        this.$set(item,"customErrorMsg", '')
        item.commissionRate = formatPositiveIntegerInput(value)
      })
    },
    async handleDelete(row){
      await this.$confirm(`是否确认删除`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })

      const list = [{
        commissionRate: row.commissionRate,
        id: row.id,
        templateCode: row.templateCode,
        userUUID: row.userUUID,
      }]

      const res = await poiApi.deleteGoods({
        list,
      })
      if(res.data.success){
        if(this.tableList.list.length - 1 === 0){
          this.params.pageNo >= 2 && this.params.pageNo --;
        }
        this.$message.success('删除成功')
      }
      this.getList();
    },
    async handleConfirmSelectProduct(data){
      const params = data.map(item =>{
        return {
          commissionRate: item.commissionRate,
          id: item.id,
          templateCode: item.templateCode,
          userUUID: this.groupRow.userUUID,
        }
      })

      this.loading = true
      const res = await poiApi.saveGoods({
        list: params,
      }).finally(()=>{
        this.loading = false
      })

      if(res.data.success){
        this.$message.success(res.data.message)
      }
      this.getList();

    },
    handleSelectProduct(){
      this.$refs.selectRef.open()
    },
    handleClose(){
      this.dialogVisible = false
    },
    async handleConfirm(){
      await this.handValidate()
      await this.$confirm(`当前有${this.changedItems.length}条数据被修改,确认是否修改?`)

      this.saveLoading = true

      await this.handleConfirmSelectProduct(this.changedItems).finally(()=>{
        this.saveLoading = false
      })
      this.handleClose()
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    open(row){
      this.params.pageNo = 1;
      this.params.pageSize = 10;
      this.groupRow = row
      this.dialogVisible = true
      this.getList()
    },
    async getList() {
      this.loading = true
      const res = await poiApi.getMyGoodsList({
        ...this.searchForm,
        userUUID: this.groupRow.userUUID,
        pageNo: this.params.pageNo,
        pageSize: this.params.pageSize,
      });
      if(res.data.code !== 200) {
        this.$message.error(res.data.message);
        return;
      }
      this.backupList = JSON.parse(JSON.stringify(res.data.data.list)) || [];
      this.tableList.list = res.data.data.list || [];
      this.tableList.total = res.data.data.total || 0;
      this.loading = false;
      this.tableList.currentPage = res.data.data.pageNo;
      this.tableList.pageSize = res.data.data.pageSize;
    },
    // 表单搜素
    onFormSearch() {
      debounce(
          () => {
            this.$refs['searchFormRef'].validate((valid) => {
              if (valid) {
                this.params.pageNo = 1;
                this.getList();
              } else {
                console.log('error submit!!');
                return false;
              }
            });
          },
          500,
          true
      );
    },
    reset() {
      this.searchForm = {
        searchContent: '',
      }
      this.params.pageNo = 1;
      this.params.pageSize = 10;
      this.$refs['searchFormRef'].resetFields();
    },
    onFormReset() {
      debounce(() => {
        this.reset()
        this.getList()
      }, 1000, true)
    },
    handleSizeChange(val) {
      this.params.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.params.pageNo = val;
      this.getList();
    },
  }
};
</script>

<style scoped lang="less">
.pagination{
  margin-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/pc/miniProgram/poiCps/components/groupSettingPop.vue